export const RecordMap = <V, NV>(
  input: Record<string, V>,
  keyFn: (value: V, key: string) => string,
  valueFn: (value: V, key: string) => NV
): Record<string, NV> =>
  Object.fromEntries(
    Object.entries(input).map(([k, v]) => [
      keyFn(v as V, k),
      valueFn(v as V, k),
    ])
  ) as Record<string, NV>
